export const CONSENT_KEY = 'contdesk-cookie-consent';
export const CONSENT_EVENT = 'contdesk:consent-change';
export const PREFERENCES_EVENT = 'contdesk:open-cookie-preferences';
export const CONSENT_VERSION = 1;
export const CONSENT_MAX_AGE = 180 * 24 * 60 * 60 * 1000;
let memoryConsent = null;

export function getConsent() {
  try {
    const saved = JSON.parse(localStorage.getItem(CONSENT_KEY) || 'null');
    if (saved?.version === CONSENT_VERSION && typeof saved.marketing === 'boolean' && saved.necessary === true && Number.isFinite(saved.updatedAt) && saved.updatedAt <= Date.now() && Date.now() - saved.updatedAt < CONSENT_MAX_AGE) return saved;
  } catch { /* Preferências podem funcionar nesta sessão quando o armazenamento está bloqueado. */ }
  if (memoryConsent && Date.now() - memoryConsent.updatedAt < CONSENT_MAX_AGE) return memoryConsent;
  return null;
}

export function hasMarketingConsent() { return getConsent()?.marketing === true; }

export function clearMarketingStorage() {
  try { sessionStorage.removeItem('contdesk-attribution'); } catch { /* Armazenamento indisponível. */ }
  if (typeof window.fbq === 'function') window.fbq('consent', 'revoke');
  const domains = ['', ...location.hostname.split('.').map((_, index, parts) => `.${parts.slice(index).join('.')}`)];
  for (const name of ['_fbp', '_fbc']) for (const domain of domains) {
    document.cookie = `${name}=; Max-Age=0; path=/;${domain ? ` domain=${domain};` : ''} SameSite=Lax`;
  }
  window.dataLayer = [];
}

export function saveConsent(marketing) {
  const previous = getConsent();
  const next = { version: CONSENT_VERSION, necessary: true, marketing: marketing === true, updatedAt: Date.now() };
  memoryConsent = next;
  try { localStorage.setItem(CONSENT_KEY, JSON.stringify(next)); } catch { /* Mantém a escolha apenas nesta sessão. */ }
  if (!next.marketing) clearMarketingStorage();
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: next }));
  // O recarregamento remove bibliotecas de publicidade já carregadas e suas tarefas pendentes.
  if (previous?.marketing && !next.marketing && window.fbq) window.location.reload();
  return next;
}

export function openCookiePreferences() { window.dispatchEvent(new Event(PREFERENCES_EVENT)); }
